import {useProject} from "./ProjectName";
import {titleHelperClip, usePageTitle} from "../../../misc/PageTitle";
import {formatProjectNumber} from "../../../api/Projects";

export function ProjectPageTitle(props: {
    title: string;
}) {
    const project = useProject();
    const ref = project && project.projectNumber > 0 ? formatProjectNumber(project.projectNumber) + " " : "";
    usePageTitle(ref + titleHelperClip(project?.name, 16) + " | " + props.title);
    return null;
}